import axios from "axios";
import apiurl from "../../server/api";
import {
  REGISTER_USER,
  SIGNIN_USER,
  UPDATE_USER,
  RESET_PASSWORD,
  CHECK_EMAIL,
  MIDDLEWARE_ON,
  MIDDLEWARE_OFF,
  ADD_DASHBOARD_NAME,
} from "../Constants/types";
import { encryptWithAES, decryptWithAES } from "../../helper/crypto";
export const register_user = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    // console.log({ body });
    axios
      .post(`${apiurl}/api/user/register`, body)
      .then((res) => {
        dispatch({
          type: REGISTER_USER,
          payload: res.data,
        });
        resolve(res);
      })
      .catch((err) => {
        reject(err.response.data);
      });
  });
};

export const signin_user = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    // console.log({ body });
    axios
      .post(`${apiurl}/api/user/vendor_login`, body)
      .then((res) => {
        // console.log(res, res.data.email);
        const en_email = encryptWithAES(res.data.email);
        const res_data = encryptWithAES(JSON.stringify(res.data));
        localStorage.setItem("email", en_email);
        localStorage.setItem("token", res.data.access);
        localStorage.setItem("res", res_data);

        dispatch({
          type: SIGNIN_USER,
          payload: res.data,
        });
        dispatch({
          type: MIDDLEWARE_OFF,
        });
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const update_user = (id, body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    // console.log({ body });
    axios
      .post(`${apiurl}/api/user/update/${id}`, body)
      .then((res) => {
        dispatch({
          type: UPDATE_USER,
          payload: res.data,
        });
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const reset_password = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    // console.log({ body });
    axios
      .post(`${apiurl}/api/user/reset_password`, body)
      .then((res) => {
        dispatch({
          type: RESET_PASSWORD,
          payload: res.data,
        });
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const check_email = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    // console.log({ body });
    axios
      .post(`${apiurl}/api/user/forgot_password`, body)
      .then((res) => {
        dispatch({
          type: CHECK_EMAIL,
          payload: res.data,
        });
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const signin_user_by_refresh = (access) => (dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      headers: {
        Authorization: `JWT ${access}`,
      },
    };
    axios
      .get(`${apiurl}/api/user/fetch_refresh_details`, headers)
      .then((res) => {
        // console.log(res,res.data.email);
        const en_email = encryptWithAES(res.data.email);
        const res_data = encryptWithAES(JSON.stringify(res.data));
        localStorage.setItem("email", en_email);
        localStorage.setItem("token", res.data.access);
        localStorage.setItem("res", res_data);
        dispatch({
          type: SIGNIN_USER,
          payload: res.data,
        });
        dispatch({
          type: MIDDLEWARE_OFF,
        });

        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const fetch_access = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch({
      type: MIDDLEWARE_ON,
    });

    // console.log({body});
    axios
      .post(`${apiurl}/api/user/refresh`, body)
      .then((res) => {
        // console.log(res,res.data.access);

        dispatch(signin_user_by_refresh(res.data.access));

        resolve(res);
      })
      .catch((err) => {
				if(err.response?.status === 401){
					localStorage.clear();
					window.location.replace("/")
				}
        reject(err);
      });
  });
};

export const set_user_details = () => (dispatch) => {
  const fetch_res = localStorage.getItem("res");
  if (fetch_res) {
    const res = JSON.parse(decryptWithAES(fetch_res));
    // console.log({ res });

    dispatch({
      type: SIGNIN_USER,
      payload: res,
    });
  }
};

export const setCurrentDashboardName = (DataList) => (dispatch) => {
  const data_str = window.location.pathname;
  const res_obj = DataList.filter((obj) => {
    if (obj.to === "/") {
      return data_str === "/";
    }

    return data_str === obj.to || data_str.startsWith(`${obj.to}/`);
  });
  if (res_obj.length) {
    dispatch({
      type: ADD_DASHBOARD_NAME,
      payload: res_obj[0].title,
    });
  }
};
